import type { DmThreadStatus } from "../../app/services/dmThreads";

export type DmWorkflowToastKind = "offer" | "accepted" | "delivery" | "inspection";

const DRAFT_STATUSES = new Set<string>(["new", "draft"]);

/**
 * status 遷移からワークフロートースト種別を判定する。
 * 対象外の遷移（差し戻し・辞退・内容編集のみ等）は null。
 */
export const resolveDmWorkflowToastKind = (
  prev: DmThreadStatus | string | undefined | null,
  next: DmThreadStatus | string | undefined | null,
): DmWorkflowToastKind | null => {
  if (!prev || !next || prev === next) return null;

  if (DRAFT_STATUSES.has(prev) && next === "contractor_pending") {
    return "offer";
  }
  if (
    prev === "contractor_pending" &&
    (next === "in_progress" || next === "inspection_pending")
  ) {
    return "accepted";
  }
  if (prev === "in_progress" && next === "inspection_pending") {
    return "delivery";
  }
  if (prev === "inspection_pending" && next === "completed") {
    return "inspection";
  }
  return null;
};

export const formatDmWorkflowToastMessage = (
  kind: DmWorkflowToastKind,
  requesterName: string,
  contractorName: string,
): string => {
  const requester = requesterName.trim() || "相手";
  const contractor = contractorName.trim() || "相手";

  switch (kind) {
    case "offer":
      return `${requester}さんよりオファー`;
    case "accepted":
      return `${contractor}さんとのオファー成立`;
    case "delivery":
      return `${contractor}さんより納品`;
    case "inspection":
      return `${requester}さんより検収`;
  }
};
